<template>
  <div>
    <div class="contract">
      <Header :groupService="dataContract.groupService"></Header>
      <p class="txt-center fonsize-16 txt-tranf">
        <b>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM </b>
      </p>
      <p class="txt-center fonsize-16">
        <b>Độc lập – Tự do – Hạnh phúc</b>
      </p>
      <p class="txt-center fonsize-16">***</p>
      <p class="txt-tranf txt-center fonsize-20">
        <b
          >HỢP ĐỒNG HỢP TÁC<br />
          CHẤP NHẬN THANH TOÁN</b
        >
      </p>
      <p class="txt-center">
        (Số: <mark>{{ dataContract.code }}</mark
        >)
      </p>
      <h3>Căn cứ:</h3>
      <ul class="form-style">
        <li>
          Bộ Luật Dân sự được Quốc hội nước Cộng hòa xã hội chủ nghĩa Việt Nam thông qua ngày 24
          tháng 11 năm 2015, có hiệu lực từ ngày 01 tháng 01 năm 2017 và các văn bản hướng dẫn thi
          hành;
        </li>
        <li>
          Luật Thương mại được Quốc hội nước Cộng hòa xã hội chủ nghĩa Việt Nam thông qua ngày 14
          tháng 6 năm 2005, có hiệu lực từ ngày 01 tháng 01 năm 2006 và các văn bản hướng dẫn thi
          hành;
        </li>
        <li>
          Nghị định số 52/2024/NĐ-CP của Chính phủ về thanh toán không dùng tiền mặt có hiệu lực từ
          ngày 01/7/2024;
        </li>
        <li>
          Thông tư số 15/2024/TT-NHNN ngày 28 tháng 6 năm 2024 của Ngân hàng Nhà nước Việt Nam quy
          định về cung ứng dịch vụ thanh toán không dùng tiền mặt;
        </li>
        <li>
          Thông tư số 40/2024/TT-NHNN ngày 17 tháng 7 năm 2024 của Ngân hàng Nhà nước Việt Nam quy
          định về hoạt động cung ứng dịch vụ trung gian thanh toán;
        </li>
        <li>Nhu cầu và khả năng của các Bên.</li>
      </ul>
      <p>
        Hôm nay, ngày
        <mark>{{ dataContract.effectiveFromDTO | formatDate }}</mark
        >, tại trụ sở Công ty Cổ phần Công nghệ Vi Mô, chúng tôi gồm có:
      </p>
      <p class="fonsize-16 txt-tranf">
        <b>BÊN A: CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b>
      </p>
      <p><b>(sau đây được gọi là “BÊN A”)</b></p>
      <p>
        Địa chỉ: Tầng 12A, tòa nhà VTC online số 18 Đường Tam Trinh, Phường Tương Mai, Thành phố Hà
        Nội, Việt Nam.
      </p>
      <p>Điện thoại: 1900 - 2079</p>
      <p>Mã số thuế: 0106393463</p>
      <p>Điện thoại: 1900 - 2079</p>
      <p>Mã số thuế: 0106393463</p>
      <ul class="form">
        <li>
          Đại diện: Ông
          <b
            v-if="
              dataAppendix?.dateSignAppendixDTO ||
              dataAppendix?.dateCreatedAppendixDTO ||
              dataContract?.effectiveFromDTO
                ? (dataAppendix?.dateSignAppendixDTO ||
                    dataAppendix?.dateCreatedAppendixDTO ||
                    dataContract?.effectiveFromDTO) < new Date('2026-01-07').getTime()
                : new Date() < new Date('2026-01-07')
            "
            >ĐỖ CÔNG DIỄN</b
          >
          <b v-else>NGUYỄN TIẾN LƯỢNG</b>
        </li>
        <li>Chức vụ: <b>Tổng Giám Đốc</b></li>
      </ul>
      <p class="fonsize-16 txt-tranf flex">
        <span> <b>BÊN B:</b></span>
        <mark
          ><b>{{ customerInfo ? customerInfo.merchantName : '' }}</b></mark
        >
      </p>
      <p><b>(sau đây được gọi là “BÊN B”)</b></p>
      <p>
        <span>Địa chỉ:</span>
        <mark
          >{{ customerInfo ? customerInfo.address : 'Không có' }}
          <!-- {{ customerInfo ? customerInfo.ward : "Không có" }},
          {{ customerInfo ? customerInfo.district : "Không có" }},
          {{ customerInfo ? customerInfo.city : "Không có" }} -->
        </mark>
      </p>
      <p v-if="customerInfo && customerInfo.businessRegistrationNumber">
        <span>Mã số thuế: </span>
        <mark>{{ customerInfo ? customerInfo.businessRegistrationNumber : '' }}</mark>
      </p>
      <p>
        <span>Đại diện theo pháp luật: </span>
        <mark
          ><b>{{ customerInfo ? customerInfo.customerName : '' }}</b></mark
        >
        <span>; Chức vụ: </span>
        <mark
          ><b>{{ customerInfo ? customerInfo.position : '' }}</b></mark
        >
      </p>
      <p>
        <span>Số CMND/Hộ chiếu/Thẻ căn cước:</span>
        <mark>{{ customerInfo ? customerInfo.passport : '' }}</mark>
        <span>; Nơi cấp:</span>
        <mark>{{ customerInfo ? customerInfo.placeOfIssue : '' }}</mark>
      </p>
      <p>
        <span>Điện thoại:</span>
        <mark>
          {{ customerInfo ? customerInfo.mobile : '' }}
        </mark>
        <span
          v-if="!(customerInfo && customerInfo.accIdType && customerInfo.accIdType === 'MOBILE')"
          >; Email:
          <mark>{{ customerInfo ? customerInfo.email : '' }}</mark>
        </span>
      </p>
      <p>&nbsp;</p>
      <p>
        Sau khi xem xét các điều khoản và điều kiện của Hợp đồng, chúng tôi cùng đồng ý ký kết và
        thực hiện các điều khoản dưới đây:
      </p>
      <ol class="form-style1">
        <li>
          <h1>nội dung hợp tác</h1>
          <p>
            Bên A là một pháp nhân hoạt động hợp pháp trong lĩnh vực Trung gian thanh toán đã được
            Ngân hàng Nhà nước Việt Nam cấp giấy phép hoạt động số 30/GP-NHNN, ngày 22/02/2016; bằng
            năng lực của mình, thực hiện việc cung cấp dịch vụ chấp nhận thanh toán thẻ và QRCode
            cho Khách hàng dưới các điều khoản và điều kiện trong Hợp đồng này.
          </p>
          <p>
            Bên B là một cá nhân hoặc pháp nhân hoạt động hợp pháp trong lĩnh vực
            <mark>{{
              customerInfo ? customerInfo.mcc : '' | transfromMccName(dataConfigMcc)
            }}</mark>
            hiểu và đồng ý các điều khoản và điều kiện cho việc chấp thuận sử dụng dịch vụ của Bên A
            cung cấp trên tinh thần thiện chí hợp tác, tự nguyện, cùng có lợi.
          </p>
          <p>
            Vì vậy, các bên thống nhất ký kết hợp đồng này với phạm vi công việc và mục đích sau:
          </p>
          <ul class="form-style">
            <li>
              Hợp đồng này quy định quyền lợi và trách nhiệm của các Bên trong việc ký kết và thực
              hiện
              <b>“Hợp đồng hợp tác chấp nhận thanh toán QRCode”</b> (viết tắt là <b>“Hợp đồng”</b>),
              cho phép Khách hàng có thể sử dụng QRCode do ngân hàng và các ví điện tử nội địa để
              thanh toán tiền hàng hoá, dịch vụ.
            </li>
            <li>
              Bên B đồng ý sử dụng dịch vụ của Bên A theo các Điều khoản được quy định trong nội
              dung Hợp đồng này cùng các Phụ lục hợp đồng kèm theo.
            </li>
          </ul>
        </li>
        <li>
          <h1>PHÍ GIAO DỊCH</h1>
          <ol>
            <li>
              <span class="txt-bold"> Mức phí giao dịch</span>
              <ul>
                <li>
                  Mức phí giao dịch được quy định chi tiết trong Phụ lục đính kèm Hợp đồng này.
                </li>
                <li>
                  Khi có sự thay đổi về chính sách phí áp dụng; Bên A sẽ tiến hành gửi Công văn
                  thông báo đến Bên B qua email Bên B đã đăng ký tài khoản trên hệ thống của Bên A.
                  Công văn thông báo này có giá trị pháp lý như một phần không tách rời khỏi Hợp
                  đồng Hợp tác Chấp nhận thanh toán đã ký giữa Bên A & Bên B.
                </li>
              </ul>
            </li>
            <li>
              <span class="txt-bold">Cơ sở tính phí và hình thức thanh toán phí</span>
              <ul>
                <li>
                  Phí được tính toán theo từng giao dịch thành công trên hệ thống của Bên A, căn cứ
                  trên số lượng và tổng số tiền Giao dịch thành công.
                </li>
                <li>
                  Phí giao dịch được khấu trừ trực tiếp trên tổng số tiền Bên A thanh toán cho Bên B
                  theo chu kỳ được quy định tại Điều 4 của Hợp đồng này.
                </li>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <h1>THÔNG TIN TÀI KHOẢN VÀ ĐẦU MỐI LIÊN HỆ</h1>
          <ol>
            <li>
              <span class="txt-bold">Thông tin đăng ký tài khoản</span>
              <ul>
                <p>
                  - Bên B đồng ý sử dụng các thông tin sau để đăng ký tài khoản trên hệ thống thanh
                  toán của Bên A:
                </p>
                <table>
                  <tr>
                    <td style="border-top: 1px">Email đăng ký mở tài khoản (bắt buộc)</td>
                    <td style="border-top: 1px">
                      <span
                        v-if="
                          !(
                            customerInfo &&
                            customerInfo.accIdType &&
                            customerInfo.accIdType === 'MOBILE'
                          )
                        "
                        >{{ customerInfo ? customerInfo.email : '' }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>SĐT đăng ký mở tài khoản (bắt buộc)</td>
                    <td>
                      {{ customerInfo ? customerInfo.mobile : '' }}
                    </td>
                  </tr>
                  <tr>
                    <td>Địa chỉ Kinh doanh trên đăng ký kinh doanh (bắt buộc)</td>
                    <td>
                      {{ customerInfo ? customerInfo.address : 'Không có' }}
                      <!-- {{ customerInfo ? customerInfo.district : "Không có" }},
                      {{ customerInfo ? customerInfo.city : "Không có" }} -->
                    </td>
                  </tr>
                  <tr>
                    <td>Số Đăng ký Kinh doanh (bắt buộc)</td>
                    <td>
                      {{ customerInfo ? customerInfo.businessRegistrationNumber : '' }}
                    </td>
                  </tr>
                  <tr
                    v-if="
                      customerInfo.enableSendMonthlyReport &&
                      customerInfo.enableSendMonthlyReport === true
                    "
                  >
                    <td>Thông tin xuất hóa đơn</td>
                    <td>
                      <p>
                        Tên công ty:
                        {{ customerInfo ? customerInfo.invoiceMcName : '' }}
                      </p>
                      <p>
                        Địa chỉ:
                        {{ customerInfo ? customerInfo.invoiceMcAddress : '' }}
                      </p>
                      <p>
                        Mã số thuế:
                        {{ customerInfo ? customerInfo.invoiceMcBusinessNumber : '' }}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>Thông tin người đại diện ký hợp đồng với Vimo (Bắt buộc)</td>
                    <td>
                      <p>
                        Họ tên:
                        {{ customerInfo ? customerInfo.customerName : '' }}
                      </p>
                      <p>Chức vụ: {{ customerInfo ? customerInfo.position : '' }}</p>
                      <p>Email: {{ customerInfo ? customerInfo.email : '' }}</p>
                      <p>SĐT: {{ customerInfo ? customerInfo.mobile : '' }}</p>
                      <p>
                        Số CCCD/CMT:
                        {{ customerInfo ? customerInfo.passport : '' }}
                      </p>
                    </td>
                  </tr>
                </table>
              </ul>
            </li>
            <li>
              <span class="txt-bold">Thông tin đầu mối liên hệ</span>
              <ul class="">
                <table width="100%">
                  <thead class="thead-light">
                    <tr>
                      <th scope="cul" class="text-left"></th>
                      <th scope="cul" class="text-center">Bên A</th>
                      <th scope="cul" class="text-center">Bên B</th>
                    </tr>
                  </thead>
                  <tbody v-for="(item, i) in mergedData" :key="i">
                    <tr class="table-row">
                      <td class="text-left">{{ item.name }}</td>
                      <td class="text-left">
                        <p v-if="item.emailAside">Email: {{ item.emailAside }}</p>
                        <p v-if="item.mobileAside">Hotline: {{ item.mobileAside }}</p>
                      </td>
                      <td class="text-left">
                        <p v-if="item.email">Email: {{ item.email }}</p>
                        <p v-if="item.mobile">Hotline: {{ item.mobile }}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <h1>ĐỐI SOÁT VÀ THANH QUYẾT TOÁN</h1>
          <ol>
            <li>
              <span class="txt-bold">Nguyên tắc thanh toán</span>
              <ul>
                <li>Đồng tiền thanh toán là tiền Việt Nam (VNĐ)</li>
                <li>
                  <p>
                    Gọi ngày giao dịch là T, vào
                    <b>Ngày làm việc</b> [<b class="clred">T+1</b>] (<i
                      >là ngày theo Dương lịch, không bao gồm các ngày thứ Bảy, Chủ nhật và các ngày
                      nghỉ lễ theo quy định pháp luật của Việt Nam</i
                    >), Bên A tiến hành thanh toán cho Bên B số tiền theo nguyên tắc như sau:
                  </p>
                  <p>
                    <b>Số tiền thanh toán</b> = [<b>Tổng tiền Giao dịch thành công</b>] – [<b
                      >Tổng phí Giao dịch</b
                    >] – [<b>Tổng tiền Giao dịch hoàn trả </b><i>(nếu có)</i>].
                  </p>
                </li>
                <li>Phí chuyển tiền do ngân hàng của Bên A thu (nếu có), do Bên A chi trả.</li>
                <li>Phí nhận tiền do ngân hàng của Bên B thu (nếu có), do Bên B chi trả.</li>
                <li>
                  Riêng kênh QR Code VietQR, số tiền giao dịch tối thiểu được chấp nhận và thanh
                  toán qua hệ thống Bên A là 1.000 VNĐ (Một nghìn Việt Nam Đồng) và số tiền tối
                  thiểu Bên A thanh toán cho BÊN B là 50.000 VNĐ (Năm mươi nghìn Việt Nam Đồng) cho
                  mỗi lần thanh toán
                  <!-- BÊN A thanh toán cho BÊN B số tiền của các giao dịch từ
                  <b>3.000 VNĐ</b> <i>(Ba nghìn Việt Nam Đồng)</i>/ giao dịch
                  trở lên (riêng kênh QR Code VietQR, số tiền giao dịch tối
                  thiểu được chấp nhận và thanh toán qua hệ thống Bên A là 1.000
                  VNĐ) và số tiền tối thiểu BÊN A thanh toán cho BÊN B là
                  <b>100.000 VNĐ</b> (Một trăm nghìn Việt Nam Đồng) trong mỗi
                  lần thanh toán. Riêng kênh QR Code VietQR, số tiền giao dịch tối thiểu được chấp nhận và thanh toán qua hệ thống Bên A là 1.000 VNĐ (Một nghìn Việt Nam Đồng) và số tiền tối thiểu Bên A thanh toán cho BÊN B là 50.000 VNĐ (Năm mươi nghìn Việt Nam Đồng) cho mỗi lần thanh toán. -->
                </li>
              </ul>
            </li>
            <li>
              <span class="txt-bold">Hình thức thanh toán</span>
              <ul>
                <li>
                  Bên A thanh toán bằng hình thức chuyển khoản qua ngân hàng tới số tài khoản ngân
                  hàng của Bên B theo thông tin như sau:
                </li>
                <table>
                  <tr>
                    <td style="border-top: 1px">Loại tài khoản</td>
                    <td style="border-top: 1px">VND</td>
                  </tr>
                  <tr>
                    <td class="text-danger">Tên người thụ hưởng</td>
                    <td>
                      {{ customerInfo ? customerInfo.holderName : '' }}
                    </td>
                  </tr>
                  <tr>
                    <td>Số tài khoản ngân hàng</td>
                    <td>
                      {{ customerInfo ? customerInfo.accountNo : '' }}
                    </td>
                  </tr>
                  <tr>
                    <td>Tại ngân hàng</td>
                    <td>
                      {{ customerInfo ? customerInfo.bankName : '' }}
                    </td>
                  </tr>
                  <!-- <tr>
                    <td>Chi nhánh ngân hàng</td>
                    <td>
                      {{ customerInfo ? customerInfo.branch : '' }}
                    </td>
                  </tr> -->
                  <!-- <tr>
                    <td>Tại Tỉnh/ Thành phố</td>
                    <td>
                      {{ customerInfo ? customerInfo.bankCityName : '' }}
                    </td>
                  </tr> -->
                </table>

                <li>
                  Khi Bên B có nhu cầu thay đổi tài khoản ngân hàng, hai Bên cần xác nhận bằng văn
                  bản hoặc thông báo từ Bên B bằng email đã đăng ký trên hệ thống của Bên A.
                </li>
              </ul>
            </li>
            <li
              v-if="
                customerInfo.enableSendMonthlyReport &&
                customerInfo.enableSendMonthlyReport === true
              "
            >
              <span class="txt-bold">Đối soát và xuất hóa đơn giá trị gia tăng</span>
              <div>
                Hàng tháng Bên A gửi Bên B file đối soát giao dịch từ 00h00’ ngày 25 tháng trước đến
                23h59’ ngày 24 của tháng đối soát để hai bên đối soát dữ liệu. Trong vòng 03 ngày
                (là ngày dương lịch, không bao gồm các ngày thứ Bảy, Chủ nhật và các ngày nghỉ lễ
                theo quy định của pháp luật Việt Nam), nếu Bên B không có phản hồi về đối soát, Bên
                A sẽ ghi nhận số liệu và xuất hóa đơn giá trị gia tăng phần phí mà Bên A thu của Bên
                B.
              </div>
            </li>
          </ol>
        </li>
        <li>
          <h1>DANH SÁCH ĐIỂM CHẤP NHẬN THANH TOÁN CỦA BÊN B</h1>
          <div class="p-4">
            <table>
              <thead class="thead-light">
                <tr>
                  <th scope="col" class="text-left">Tên điểm chấp nhận</th>
                  <th scope="col" class="text-left">Địa chỉ</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in dataContract.merchantBusinessAreas" :key="index">
                <tr class="table-row">
                  <td class="text-left">{{ item.areaName }}</td>
                  <td align="left">
                    {{ item.areaAddress }}
                    <!-- <span v-show="item.areaDistrict">
                      - {{ item.areaDistrict }}</span>
                    <span v-show="item.areaCity"> - {{ item.areaCity }}</span> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
        <li>
          <h1>QUYỀN VÀ TRÁCH NHIỆM CỦA BÊN A</h1>
          <ol>
            <li>
              <span class="txt-bold">Quyền của Bên A</span>
              <ul>
                <li>Được hưởng phí xử lý giao dịch quy định tại Điều 2 của Hợp đồng này.</li>
                <li>
                  Được quyền tạm dừng thanh toán cho Bên B cho đến khi Bên B cung cấp đầy đủ các
                  chứng từ mua bán hàng hóa, cung ứng dịch vụ và được xác minh là hợp pháp, hợp lệ
                  bởi (các) bên có thẩm quyền (Ngân hàng thanh toán, Bên A,...) đối với các giao
                  dịch nghi ngờ gian lận, giả mạo, giao dịch thanh toán khống (không phát sinh việc
                  mua bán hàng hóa và cung ứng dịch vụ); giao dịch nghi ngờ liên quan đến hoạt động
                  rửa tiền, tài trợ khủng bố, tài trợ phổ biến vũ khí hủy diệt hàng loạt, vi phạm
                  pháp luật; hoặc giao dịch tra soát (là các giao dịch có khiếu nại của khách hàng
                  hoặc do ngân hàng xử lý giao dịch yêu cầu tra soát bao gồm nhưng không giới hạn:
                  các giao dịch nghi ngờ có giá trị bất thường so với ngành hàng của Bên B, giao
                  dịch thực hiện liên tiếp bất thường, ….) có yếu tố nghi ngờ tương tự, các giao
                  dịch có dấu hiệu đáng ngờ theo quy định của pháp luật về phòng, chống rửa tiền và
                  tài trợ khủng bố, tài trợ phổ biến vũ khí hủy diệt hàng loạt.
                </li>
                <li>
                  Từ chối thanh toán hoặc truy đòi một phần/ toàn bộ các khoản đã thanh toán cho Bên
                  B đối với các giao dịch thuộc một trong các trường hợp sau:

                  <p>
                    (i) Bên B có hành vi hoặc tạo điều kiện để thực hiện hành vi gian lận, không
                    thực hiện theo đúng hướng dẫn và quy định tại Hợp đồng này hoặc tại các quy định
                    của Bên A đã được thông báo bằng văn bản hoặc trên ứng dụng của Bên A cung cấp
                    cho Bên B trong quá trình sử dụng dịch vụ;
                  </p>
                  <p>
                    (ii) Ngân hàng thanh toán, đơn vị cung ứng dịch vụ thanh toán yêu cầu kiểm tra,
                    tra soát Bên B hoặc các giao dịch của Bên B;
                  </p>
                  <p>(iii) Các giao dịch bị Khách hàng khiếu kiện, khiếu nại.</p>
                </li>
                <li>
                  Phối hợp với Bên B để tra soát và hoàn tiền cho các giao dịch mà khách hàng đã trừ
                  tiền trên tài khoản nhưng chưa được hệ thống của Bên A ghi nhận thành công cho Bên
                  B hoặc Bên B có nhu cầu hoàn lại tiền cho khách hàng khi khách hàng huỷ đơn hàng.
                </li>
                <li>
                  Được quyền từ chối và/ hoặc tạm dừng việc thực hiện nghĩa vụ thanh toán của Bên A
                  trong trường hợp Bên B vi phạm bất kỳ nghĩa vụ thanh toán nào đã được quy định
                  trong Hợp đồng này.
                </li>
                <li>
                  Được quyền kiểm tra, kiểm soát và tạm dừng ghi nhận giao dịch đối với các giao
                  dịch mà Bên A nghi ngờ có sự gian lận của khách hàng hoặc từ chối giao dịch đối
                  với các giao dịch phát hiện có sự gian lận của khách hàng hoặc Bên B. Tùy từng
                  trường hợp vi phạm của Bên B, Bên A sẽ thông báo bằng văn bản đến Bên B.
                </li>
                <li>
                  Bên A được quyền kiểm tra thực tế điểm chấp nhận thanh toán của Bên B để đánh giá
                  về tính phù hợp của giấy tờ chứng minh loại hình kinh doanh, việc tuân thủ các quy
                  định tại Hợp đồng và hướng dẫn của Bên A.
                </li>
                <li>
                  Bên A được quyền nêu tên Bên B theo quy định của pháp luật trong các chiến dịch
                  quảng bá chương trình có nội dung phù hợp với loại hình kinh doanh của Bên B mà
                  Bên A có thể sẽ thực hiện trong thời hạn của Hợp đồng này.
                </li>

                <li>
                  Từ chối thực hiện quảng cáo cho Bên B nếu Bên B không tuân thủ các quy định tại
                  Hợp đồng này hoặc vi phạm các quy định của pháp luật.
                </li>

                <li>
                  Chấm dứt Hợp đồng và ngừng cung cấp dịch vụ chấp nhận thanh toán trên hệ thống của
                  Bên A nếu Bên B có hành vi gian lận (như tự ý sao chép thông tin tài khoản của
                  khách hàng) hoặc không tuân thủ các quy định liên quan đến giao dịch thanh toán
                  được quy định tại Hợp đồng này và các Phụ lục kèm theo mà Bên A đã hướng dẫn.
                </li>
              </ul>
            </li>
            <li>
              <span class="txt-bold"> Trách nhiệm của Bên A</span>
              <ul>
                <li>
                  Đảm bảo bí mật các thông tin về Bên B, chỉ được phép tiết lộ thông tin khi có yêu
                  cầu của cơ quan chức năng theo quy định của pháp luật hoặc theo yêu cầu của Hợp
                  đồng này và phải thông báo cho Bên B biết nội dung đã tiết lộ, trừ khi pháp luật
                  hoặc Hợp đồng này có quy định khác.
                </li>
                <li>
                  Thanh toán đầy đủ, đúng hạn các giao dịch hợp lệ phát sinh theo Điều 4 Hợp đồng
                  này, trừ trường hợp Hợp đồng này có quy định khác.
                </li>
                <li>Giải quyết các yêu cầu tra soát, khiếu nại của Bên B.</li>
                <li>
                  Bên A hoàn toàn không chịu trách nhiệm đối với những tranh chấp liên quan đến các
                  điều khoản và điều kiện được thỏa thuận, ký kết giữa Bên B và Khách hàng của Bên
                  B.
                </li>
                <li>
                  Lên kế hoạch & thông báo cho bên B về lịch trình kiểm tra/ bảo trì thiết bị định
                  kỳ tại các điểm chấp nhận thanh toán của bên B.
                </li>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <h1>QUYỀN VÀ TRÁCH NHIỆM CỦA BÊN B</h1>
          <ol>
            <li>
              <span class="txt-bold">Quyền của Bên B</span>
              <ul>
                <li>
                  Được sử dụng Dịch vụ thanh toán thẻ/ QRCode trên ứng dụng của Bên A để Khách hàng
                  có thể thực hiện thanh toán tiền hàng hoá, dịch vụ cho Bên B.
                </li>
                <li>
                  Được Bên A thanh toán giá trị giao dịch (sau khi đã trừ phí) đầy đủ và đúng hạn
                  cho những giao dịch Khách hàng đã thanh toán bằng thẻ/ QRCode và được ghi nhận
                  thành công trên hệ thống của Bên A theo quy định trong Điều 4 của Hợp đồng này,
                  trừ trường hợp Hợp đồng này có quy định khác.
                </li>
                <li>
                  Được quyền yêu cầu Bên A phối hợp và hỗ trợ xử lý những sai sót xảy ra trong quá
                  trình giao dịch trên hệ thống của Bên A cung cấp.
                </li>
              </ul>
            </li>
            <li>
              <span class="txt-bold">Trách nhiệm của Bên B</span>
              <ul>
                <li>
                  Thanh toán phí giao dịch cho Bên A theo quy định tại Điều 2 của Hợp đồng này.
                </li>
                <li>
                  Cam kết chỉ chấp nhận các giao dịch thanh toán được thực hiện tại điểm chấp nhận
                  thanh toán của Bên B đã đăng ký với Bên A và trên phạm vi lãnh thổ Việt Nam.
                </li>
                <li>
                  Phối hợp với Bên A thiết lập và duy trì Dịch vụ thanh toán do Bên A cung cấp.
                </li>
                <li>
                  Bên B chịu trách nhiệm giải quyết trực tiếp với Khách hàng trong tất cả các trường
                  hợp phát sinh tranh chấp, khiếu nại, khiếu kiện liên quan đến việc thực hiện giao
                  dịch và việc thực hiện các nghĩa vụ của Bên B theo thỏa thuận mua bán hàng hóa,
                  cung cấp dịch vụ được thỏa thuận giữa Bên B và Khách hàng.
                </li>
                <li>
                  Bên B cam kết miễn trừ cho Bên A toàn bộ trách nhiệm phát sinh từ/hoặc liên quan
                  đến các yêu cầu, khiếu nại, tranh chấp, đề xuất, ràng buộc, quyết định thi hành
                  bởi Bên Thứ Ba đối với các thiệt hại, phạt, nghĩa vụ tài chính thuộc phạm vi hợp
                  tác của Hợp đồng và Phụ lục này do lỗi của bên B gây ra. Đồng thời, bồi thường
                  toàn bộ thiệt hại trực tiếp (nếu có) cho Bên A trong trường hợp Bên A phải gánh
                  chịu các thiệt hại phát sinh từ Hợp đồng này mà không do lỗi Bên A gây ra và do
                  lỗi của bên B gây ra.
                </li>
                <li>
                  Bên B có trách nhiệm cung cấp chứng từ theo quy định tại điểm g & h- khoản 7.2 Hợp
                  đồng này cho Bên A trong thời gian không quá 03 (ba) ngày kể từ ngày nhận được yêu
                  cầu của Bên A
                </li>
                <li>
                  Sau thời hạn Bên A thông báo tới bên B các giao dịch khiếu nại, tranh chấp, khiếu
                  kiện, rủi ro liên quan: Bên B đã nhận được thông báo của Bên A nhưng không phản
                  hồi, Bên A không liên hệ được với Bên B bằng email hoặc số điện thoại Bên B đã
                  đăng ký với Bên A, Bên B không còn kinh doanh tại đúng địa điểm kinh doanh đã đăng
                  ký với Bên A, chứng từ Bên B cung cấp không đủ điều kiện để giải quyết giao dịch
                  khiếu nại, Bên B chậm trễ xuất trình chứng từ để giải quyết khiếu nại hoặc vì bất
                  kỳ lý do nào khác cản trở việc giải quyết khiếu nại ...do lỗi của Bên B và Bên B
                  vi phạm nghĩa vụ cung cấp chứng từ theo quy định hợp đồng, thì Bên B có trách
                  nhiệm:
                  <ol>
                    <li>
                      Nếu số tiền Bên A tạm giữ không đủ để thực hiện hoàn trả/bồi hoàn cho Khách
                      hàng/Chủ thẻ, Bên B có trách nhiệm thanh toán bổ sung số tiền còn thiếu theo
                      thông báo của Bên A bằng hình thức thực hiện giao dịch tiếp theo (quẹt thẻ,
                      MO/TO, giao dịch linkcard, QR…) hoặc chuyển khoản hoặc để Bên A thực hiện hoàn
                      trả giao dịch bị khiếu nại với các chi phí và tổn thất phát sinh (nếu có) cho
                      Chủ thẻ/Khách hàng.
                    </li>
                    <li>
                      Nếu trường hợp giao dịch khiếu nại/tranh chấp/ khiếu kiện đã được bên A thanh
                      toán cho bên B, thì bên B có trách nhiệm thanh toán toàn bộ giá trị giao dịch
                      và phí phát sinh (nếu có) cho bên A.
                    </li>
                  </ol>
                </li>
                <li>
                  Để hỗ trợ và bảo vệ bên B khi xảy ra các tranh chấp, tra soát, rủi ro,... Bên B có
                  trách nhiệm phối hợp với Bên A cung cấp các chứng từ giao dịch. Chứng từ giao dịch
                  là những chứng từ mà Bên B phải cung cấp cho Bên A khi phát sinh yêu cầu cung cấp,
                  bao gồm nhưng không giới hạn:
                  <ol>
                    <li>Hình ảnh CMT/CCCD/Hộ chiếu của Khách hàng;</li>
                    <li>
                      Hình ảnh camera kèm ngày tháng về quá trình thực hiện giao dịch thanh toán
                      giữa bên B với Khách hàng.
                    </li>
                    <li>
                      Hóa đơn cung cấp dịch vụ của bên B & Khách hàng (Hoá đơn bán hàng, phiếu xuất
                      kho, hoá đơn VAT,...);
                    </li>
                    <li>Các chứng từ và tài liệu liên quan khác.</li>
                  </ol>
                </li>
                <li>
                  Bên B có trách nhiệm lưu trữ các chứng từ liên quan đến giao dịch cung ứng hàng
                  hoá, dịch vụ cho Khách hàng/Chủ tài khoản trong thời gian 540 (năm trăm bốn mươi)
                  ngày kể từ ngày giao dịch phát sinh hoặc thời gian lâu hơn theo yêu cầu của pháp
                  luật hoặc được Bên A thông báo.
                </li>
                <li>
                  Sau thời hạn Bên A thông báo tới Bên B các giao dịch tra soát, khiếu nại, tranh
                  chấp, khiếu kiện, rủi ro liên quan,... (gọi chung là “khiếu nại”); Bên B đã nhận
                  được thông báo của Bên A nhưng không phản hồi, Bên A không liên hệ được với Bên B
                  bằng email hoặc số điện thoại Bên B đã đăng ký với Bên A, Bên B không còn kinh
                  doanh tại điểm chấp nhận thanh toán đã đăng ký với Bên A, chứng từ Bên B cung cấp
                  không đủ điều kiện để giải quyết giao dịch khiếu nại, Bên B chậm trễ xuất trình
                  chứng từ để giải quyết khiếu nại hoặc vì bất kỳ lý do nào khác cản trở việc giải
                  quyết khiếu nại,... do lỗi của Bên B và Bên B vi phạm nghĩa vụ cung cấp chứng từ
                  theo quy định của hợp đồng, thì Bên B có trách nhiệm:
                  <ol>
                    * Nếu số tiền Bên A tạm giữ không đủ để thực hiện hoàn trả/bồi hoàn cho Khách
                    hàng/Chủ tài khoản, Bên B có trách nhiệm thanh toán bổ sung số tiền còn thiếu
                    theo thông báo của Bên A bằng hình thức thực hiện giao dịch tiếp theo hoặc
                    chuyển khoản về tài khoản ngân hàng của Bên A để Bên A thực hiện hoàn trả giao
                    dịch bị khiếu nại với các chi phí và tổn thất phát sinh (nếu có) cho Khách
                    hàng/Chủ tài khoản.
                  </ol>
                  <ol>
                    Nếu trường hợp giao dịch khiếu nại đã được Bên A thanh toán cho Bên B, thì Bên B
                    có trách nhiệm thanh toán toàn bộ giá trị giao dịch và phí phát sinh (nếu có)
                    cho Bên A.
                  </ol>
                </li>
                <li>
                  Không được phép tăng giá bán và không được phép thu thêm các khoản phí xử lý thanh
                  toán hoặc áp dụng các chính sách tạo nên sự phân biệt đối xử giữa hình thức thanh
                  toán thẻ/ QRCode so với các hình thức thanh toán khác.
                </li>
                <li>
                  Thực hiện niêm yết công khai về việc không phân biệt giá hoặc thu thêm tiền, phụ
                  phí đối với các giao dịch thanh toán tiền hàng hóa, dịch vụ bằng QR Code so với
                  các hình thức thanh toán khác.
                </li>
                <li>
                  Bên B không được chia tách giá trị của bất kỳ một giao dịch nào thành hai hay
                  nhiều giao dịch nhỏ hơn tại cùng một thời điểm.
                </li>

                <li>
                  Tham gia các buổi đào tạo, hướng dẫn dịch vụ thanh toán do Bên A hoặc điểm chấp
                  nhận thanh toán tổ chức tại cửa hàng.
                </li>
                <li>
                  Xây dựng đội ngũ nhân sự và các quy trình nghiệp vụ cần thiết để hai Bên triển
                  khai Dịch vụ thanh toán do Bên A cung cấp cho việc phát triển kinh doanh của Bên
                  B.
                </li>
                <li>
                  Áp dụng các biện pháp nghiệp vụ để đảm bảo an toàn số liệu và chịu trách nhiệm bảo
                  mật hệ thống của mình để tránh hiện tượng truy cập trái phép vào mạng lưới của một
                  Bên thông qua hệ thống của Bên kia và ngược lại.
                </li>
                <li>
                  Phối hợp với Bên A đối soát và chốt số liệu giao dịch thanh toán thông qua Dịch vụ
                  thanh toán do Bên A cung cấp định kỳ hàng tháng trên hệ thống của Bên A cung cấp.
                </li>
                <li>
                  Chịu trách nhiệm giải quyết các tranh chấp, khiếu nại của Khách hàng liên quan đến
                  hàng hoá, dịch vụ đối với khách hàng của Bên B.
                </li>
                <li>
                  Cung cấp, cập nhật đầu mối liên hệ hoặc xử lý giao dịch qua email của người có
                  thẩm quyền hoặc bằng văn bản cho Bên A trước 05 (năm) ngày làm việc kể từ ngày
                  thay đổi.
                </li>
                <li>
                  Có trách nhiệm xuất chứng từ hoặc hóa đơn bán hàng hoá, dịch vụ hợp lệ cho Khách
                  hàng tương ứng với khoản tiền đã thanh toán cho hàng hoá, dịch vụ do Bên B cung
                  ứng.
                </li>
                <li>
                  Bên B có trách nhiệm cung cấp đầy đủ, chính xác thông tin chính xác của Bên B,
                  khách hàng giao dịch và chứng từ giao dịch tại Bên B theo yêu cầu của Bên A hoặc
                  Ngân hàng hoặc Cơ quan chức năng để phục vụ việc điều tra hoạt động rửa tiền, tài
                  trợ khủng bố, tài trợ phổ biến vũ khí hủy diệt hàng loạt hoặc gửi cho cơ quan có
                  thẩm quyền khi có căn cứ hoặc nghi ngờ giao dịch có dấu hiệu vi phạm theo quy định
                  của Ngân hàng và Tổ chức thẻ; quy định về Phòng, chống Rửa tiền và tài trợ khủng
                  bố, tài trợ phổ biến vũ khí hủy diệt hàng loạt; quy định của pháp luật.
                </li>
                <li>
                  Cam kết thực hiện đầy đủ và tuân thủ các quy định của Pháp luật Việt Nam và chịu
                  trách nhiệm về tính hợp pháp của hàng hóa, dịch vụ cung ứng, bao gồm:
                  <ol>
                    <li>
                      Phạm vi thực hiện cung cấp hàng hóa dịch vụ liên quan đến Hợp đồng này: trên
                      lãnh thổ Việt Nam và đúng với ngành nghề kinh doanh mà Bên B đã đăng ký với
                      Bên A.
                    </li>
                    <li>
                      Đảm bảo hàng hóa có nguồn gốc xuất xứ rõ ràng; chính xác; phù hợp với sự mô tả
                      trên bao bì, nhãn hiệu hàng hóa. Cam kết hàng hóa, dịch vụ cung ứng đạt các
                      yêu cầu về tiêu chuẩn của loại hàng hóa dịch vụ đó và phù hợp với mẫu mã hàng
                      hóa đã quảng bá đến Khách hàng.
                    </li>
                    <li>
                      Chỉ lưu hành & cung cấp các loại hàng hóa dịch vụ được phép mua bán, trao đổi
                      thực hiện theo quy định của Pháp luật hiện hành
                    </li>
                  </ol>
                </li>
                <li>
                  Phối hợp chặt chẽ và nghiêm túc với Bên A trong việc tuân thủ các Quy định của
                  Chính Phủ về Bảo vệ Dữ liệu cá nhân được nêu tại các văn bản quy phạm pháp luật;
                  cụ thể:
                  <ol>
                    <li>
                      Xác nhận đã đọc; hiểu rõ và đồng ý kí kết với Bên A Phụ lục Bảo mật về Dữ liệu
                      cá nhân được đính kèm tại Hợp đồng này.
                    </li>
                    <li>
                      Đồng ý và chấp thuận rằng Bên A có toàn quyền chỉnh sửa; cập nhật và điều
                      chỉnh một cách hợp lý nội dung chi tiết của Phụ lục Bảo về mật Dữ liệu cá nhân
                      nêu trên qua từng thời kỳ theo quy định của pháp luật.
                    </li>
                  </ol>
                </li>
                <li>
                  Thường xuyên kiểm tra, giám sát các thiết bị, công cụ chấp nhận thanh toán hàng
                  hóa, dịch vụ, tránh việc sử dụng không đúng mục đích được quy định tại Hợp đồng
                  này. Bên B phải có biện pháp để ngăn ngừa và phát hiện việc sử dụng thiết bị chấp
                  nhận thanh toán không đúng thẩm quyền.
                </li>
                <li>
                  Cung cấp, cập nhật đầu mối liên hệ hoặc xử lý giao dịch qua email của người có
                  thẩm quyền hoặc bằng văn bản cho Bên A ít nhất 05 (năm) ngày làm việc trước ngày
                  dự kiến thay đổi.
                </li>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <h1>CÁC HÀNH VI Bị NGHIÊM CẤM CỦA BÊN B</h1>
          <ul>
            <li>
              Cung cấp thông tin không trung thực trong quá trình sử dụng dịch vụ của Bên A; cung
              cấp thông tin giả mạo để đăng ký thiết bị, mở tài khoản, sử dụng dịch vụ của Bên A.
            </li>
            <li>
              Mua, bán, cung cấp hay trao đổi thông tin giao dịch dưới bất kỳ hình thức nào khi chưa
              có sự chấp thuận bằng văn bản của Bên A hoặc cơ quan nhà nước có thẩm quyền
            </li>
            <li>
              Thực hiện, tổ chức thực hiện hoặc tạo điều kiện để người khác thực hiện các hành vi
              gian lận, giả mạo; thực hiện giao dịch chấp nhận thanh toán khống (không phát sinh
              việc mua bán hàng hóa, cung ứng dịch vụ);
            </li>
            <li>
              Bên B ngừng hoạt động hoặc thay đổi thông tin đăng ký kinh doanh nhưng không thông báo
              tới Bên A theo quy định tại Hợp đồng.
            </li>
            <li>Các hành vi bị nghiêm cấm khác theo quy định của Pháp luật Việt Nam</li>
          </ul>
        </li>
        <li>
          <h1>SỬA ĐỔI VÀ CHẤM DỨT HỢP ĐỒNG</h1>
          <ul>
            <li>
              Việc sửa đổi, bổ sung, chấm dứt Hợp đồng phải được lập thành văn bản có chữ ký xác
              nhận của người có thẩm quyền của Hai bên.
            </li>
            <li>
              Hợp đồng chấm dứt khi xảy ra một trong các sự kiện sau:
              <ol>
                <li>Hai Bên thỏa thuận chấm dứt Hợp đồng;</li>
                <li>
                  Một Bên vi phạm nghĩa vụ của mình theo quy định của Hợp đồng và không sửa chữa,
                  khắc phục được vi phạm trong thời hạn do Bên kia yêu cầu;
                </li>
                <li>
                  Trường hợp Bên B có dấu hiệu gian lận hoặc vi phạm các hành vi bị nghiêm cấm tại
                  Điều 8 của Hợp đồng này hoặc có thông báo của Ngân hàng/ Cơ quan nhà nước có thẩm
                  quyền yêu cầu ngừng cung cấp dịch vụ cho Bên B, Bên A có thể chấm dứt Hợp đồng
                  ngay lập tức bằng cách thông báo cho Bên B qua điện thoại, email, công văn và sẽ
                  có hiệu lực ngay lập tức mà không phụ thuộc vào bất kỳ quy định về thời hạn nào
                  tại Hợp đồng và Bên A cũng không phải bồi thường thiệt hại cho Bên B.
                </li>
                <li>
                  Sau 30 (ba mươi) ngày kể từ ngày một/các bên gửi văn bản cho bên còn lại thông báo
                  yêu cầu chấm dứt Hợp đồng;
                </li>
                <li>Một trong các Bên bị giải thể, phá sản;</li>
                <li>Các trường hợp khác theo quy định của Pháp luật Việt Nam.</li>
              </ol>
            </li>
            <li>
              Khi Hợp đồng chấm dứt, các Bên phối hợp giải quyết toàn bộ các nội dung, bao gồm nhưng
              không giới hạn các tra soát, khiếu nại, các khoản nợ và các nghĩa vụ tài chính khác
              liên quan đến việc thực hiện Hợp đồng này.
            </li>
            <li>
              Việc chấm dứt Hợp đồng theo quy định tại Điều này sẽ không làm ảnh hưởng hoặc tác động
              đến quyền lợi, nghĩa vụ và trách nhiệm của Các Bên phát sinh trước thời điểm chấm dứt,
              bao gồm nhưng không giới hạn bởi những nội dung sau:
              <ol>
                <li>
                  Thanh toán phần Phí Dịch vụ hoặc nghĩa vụ tài chính khác Bên còn lại cũng như cho
                  Khách hàng;
                </li>
                <li>
                  Hợp tác thanh toán những giao dịch bồi hoàn (chargeback) mà đang được xử lý hoặc
                  chưa được xử lý trước khi tiến hành chấm dứt hợp đồng;
                </li>
                <li>
                  Giải quyết các vấn đề còn tồn tại liên quan đến giao dịch thực hiện tại ĐVCNTT
                  trong thời hạn 540 (năm trăm bốn mươi) ngày kể từ ngày Hợp đồng chấm dứt hiệu lực
                  theo quy định tại Hợp đồng này.
                </li>
              </ol>
            </li>
          </ul>
        </li>
        <li>
          <h1>CHUYỂN NHƯỢNG HỢP ĐỒNG</h1>
          <ul>
            <li>
              Không bên nào trong Hợp đồng này được chuyển nhượng một phần hoặc toàn bộ nghĩa vụ của
              hợp đồng cho bên thứ ba khi chưa có sự đồng ý bằng văn bản của bên còn lại.
            </li>
            <li>
              Trong trường hợp một bên trong hợp đồng tiến hành chia, tách, sáp nhập, hợp nhất thì
              toàn bộ quyền và nghĩa vụ của Hợp đồng này sẽ được chuyển giao cho pháp nhân/tổ chức
              có quan hệ chia, tách, sáp nhập, hợp nhất với pháp nhân bị chia, tách, sáp nhập và hợp
              nhất.
            </li>
          </ul>
        </li>
        <li>
          <h1>CÁC TRƯỜNG HỢP BẤT KHẢ KHÁNG</h1>
          <ol>
            <li>
              <span class="txt-bold">Sự kiện bất khả kháng:</span>
              <ul>
                <li>
                  <p>
                    Là sự kiện vượt ra ngoài khả năng kiểm soát của một Bên (“Bên bị ảnh hưởng”) và
                    không liên quan tới lỗi hoặc sự bất cẩn của Bên đó cũng như không thể thấy
                    trước, không thể tránh được và không thể khắc phục được mặc dù đã áp dụng mọi
                    biện pháp cần thiết và khả năng cho phép và làm cho Bên bị ảnh hưởng không thể
                    thực hiện được bất kỳ nghĩa vụ hay trách nhiệm nào quy định tại Hợp đồng này.
                  </p>
                </li>
                <li>
                  <p>
                    Sự kiện bất khả kháng ("<b>Sự kiện bất khả kháng</b>") bao gồm, nhưng không giới
                    hạn một trong các sự kiện sau:
                  </p>
                  <ol>
                    <li>
                      Các hiện tượng tự nhiên bao gồm: thiên tai, dịch bệnh, hoả hoạn, lũ lụt, sóng
                      thần, xoáy lốc, hạn hán, động đất cao hơn cấp thiết kế, sấm sét cao hơn mức
                      thiết kế; nhiễm hạt nhân hoặc phóng xạ.
                    </li>
                    <li>
                      Chiến tranh, hành động xâm lược, khủng bố, bạo loạn, nội chiến, phá hoại hoặc
                      các hành động thù địch khác;
                    </li>
                    <li>
                      Bãi công và các hoạt động ngừng trệ không phải do lỗi của một trong hai Bên
                      gây ra. Hỏng hóc kỹ thuật nằm ngoài tầm kiểm soát của mỗi Bên.
                    </li>
                    <li>Do thay đổi chính sách pháp luật của Nhà nước Việt Nam.</li>
                  </ol>
                </li>
              </ul>
            </li>
            <li>
              <span class="txt-bold">Thông báo:</span>
              <ul>
                <li>
                  Bên bị ảnh hưởng của Sự kiện bất khả kháng phải thông báo cho Bên kia về sự kiện,
                  tình huống gây ra Sự kiện bất khả kháng trong thời gian sớm nhất có thể nhưng
                  không được muộn hơn một (01) ngày kể từ sau khi thông tin liên lạc đã phục hồi.
                  Nhưng cũng không quá bảy (07) ngày kể từ khi xảy ra Sự kiện bất khả kháng phải
                  thông báo bằng văn bản cho Bên kia và trong vòng ba mươi (30) ngày phải gửi văn
                  bản cho Bên kia mô tả về nguyên nhân, ảnh hưởng của Sự kiện bất khả kháng đối với
                  việc thực hiện nghĩa vụ hợp đồng và gửi kèm các chứng nhận về việc xảy ra sự cố có
                  xác nhận của chính quyền địa phương.
                </li>
                <li>
                  Bất cứ các thông báo nào cũng sẽ bao gồm chi tiết về sự kiện, tình huống tạo thành
                  Sự kiện bất khả kháng, tác động của nó đối với việc thực hiện nghĩa vụ Hợp đồng
                  của Bên bị ảnh hưởng và kiến nghị các biện pháp khắc phục. Bên bị ảnh hưởng phải
                  cung cấp các báo cáo thường xuyên cho Bên kia về việc triển khai các biện pháp
                  khắc phục nhằm ngăn chặn hoặc giảm nhẹ những tác động của Sự kiện bất khả kháng và
                  các thông tin mà Bên kia yêu cầu một cách hợp lý.
                </li>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <h1>CÁC ĐIỀU KHOẢN KHÁC</h1>
          <ul>
            <li>
              Hợp đồng này có hiệu lực trong vòng 01 (một) năm kể từ ngày ký. Trong vòng 30 (ba
              mươi) ngày trước khi hợp đồng hết hạn, nếu các bên không có thoả thuận nào khác, hợp
              đồng sẽ tự động được gia hạn liên tục 01 (một) năm một lần.
            </li>
            <li>
              Nếu một bên có bất kỳ sự thay đổi nào trong quá trình thực hiện hợp đồng, phải có
              nghĩa vụ thông báo bằng văn bản, qua email hoặc các hình thức khác (được bên kia chấp
              nhận) với bên còn lại trước ít nhất 07 (bảy) ngày kể từ ngày có sự thay đổi. Trong
              vòng 07 (bảy) ngày làm việc kể từ ngày nhận thông tin thay đổi, nếu bên nhận thông tin
              không có bất cứ phản hồi nào thì thông tin thay đổi sẽ được tự động áp dụng.
              <p>
                Đối với các thông tin thay đổi liên quan đến đăng ký kinh doanh (do cơ quan nhà nước
                có thẩm quyền của Việt Nam cấp/xác nhận), Bên có sự thay đổi phải thông báo cho Bên
                còn lại trong vòng 07 (bảy) ngày làm việc kể từ ngày nhận được văn bản của cơ quan
                nhà nước có thẩm quyền cấp.
              </p>
            </li>
            <li>
              Các bên cam kết nghiêm chỉnh thực hiện Hợp đồng này. Nếu có tranh chấp phát sinh,
              trước hết các bên sẽ cùng giải quyết bằng thương lượng. Nếu không giải quyết được, một
              trong các bên được quyền đưa tranh chấp ra Toà án có thẩm quyền để giải quyết theo thủ
              tục tố tụng được quy định bởi pháp luật Việt Nam.
            </li>
            <li>
              Hợp đồng này được lập thành 02 (hai) bản có giá trị như nhau; mỗi Bên giữ 01 (một) bản
              để thực hiện.
            </li>
          </ul>
        </li>
      </ol>
      <Footer
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="false"
      ></Footer>
    </div>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import Header from '../block/header.vue'
  import Footer from '../block/footer.vue'

  export default {
    props: ['dataContract', 'tableContactInfos'],
    components: {
      Header,
      Footer,
    },
    data() {
      return {
        dataConfigMcc: Config.businessFields,
        systemConfig: {},
        bankConfig: [
          'VNCB - NH TNHH MTV XÂY DỰNG VN',
          'CTB - CITIBANK - NH CITI',
          'IBK - NH CÔNG NGHIỆP HÀN QUỐC CN VN',
          'SMB - SUMITOMO MITSUI BANKING CORPORATION',
        ],
      }
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      mergedData() {
        return this.tableContactInfos.map(itemA => {
          const tableB = this.customerInfo.supportContactInfos
          const matchedTable = tableB.find(itemB => itemB.code === itemA.code)
          console.log(' ')
          if (matchedTable) {
            return {
              ...itemA,
              ...matchedTable,
            }
          } else {
            return itemA
          }
        })
      },
    },
    created() {},
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
